import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/auth_context';
import ProtectedRoute from '../auth/protected_route';
import { protectedRoutes as getProtectedRoutes, publicRoutes } from './router_config';
import AppHeader from '../components/common/layout/AppHeader';
import Breadcrumbs from '../components/common/layout/Breadcrumbs';

function AuthenticatedRouter() {
  const { token, isAuthReady } = useAuth();
  const location = useLocation();
  const publicPaths = publicRoutes.map(route => route.path);
  const isPublicRoute = publicPaths.includes(location.pathname);



  // Show loading only for protected routes when auth is not ready
  if (!isPublicRoute && !isAuthReady) {
    return <div>Loading...</div>;
  }

  // Create protected routes
  const protectedRoutes = getProtectedRoutes();

  // Helper to clone element with extraProps if they are defined.
  const applyExtraProps = (route) => {
    if (route.extraProps) {
      return React.cloneElement(route.element, route.extraProps);
    }
    return route.element;
  };



  return (
    <div className="authenticated-router">
      <AppHeader />
      <Breadcrumbs />
      <Routes>
        {protectedRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<ProtectedRoute>{applyExtraProps(route)}</ProtectedRoute>}
          />
        ))}
        {publicRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </div>
  );
}

export default AuthenticatedRouter;